import { defineStore } from 'pinia'

import type { SummarizeStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useAiSummarizeStore = defineStore('ai-summarize', {
  state: (): SummarizeStore => ({
    show: false,
    bookingId: null,
    summaryId: null,
    duration: null,
    speakingTime: null,
    lessonDate: null,
    summary: null,
    recordingUrl: null,
    topic: null,
    highlights: [],
    homeActivities: [],
    homeTasks: [],
    loading: false,
    rating: null,
    comment: null,
    survey: false,
    title: null,
    bannerFeedback: false,
    seekTime: null,
  }),
  actions,
  getters,
})
